export const STEP_1_FIELDS = [
  "companyName",
  "street",
  "zipCode",
  "city",
  "country",
  "sector",
  "volume",
  "currency",
  "suppliers",
  "reasons",
  "taxId",
] as const;

export const STEP_2_FIELDS = ["fullName", "jobTitle", "email", "telephone", "marketingConsent"] as const;
